import {
  getCoordinationContentMaxLengthError,
  inquiryCoordinationSchema,
  isCoordinationContentValid,
} from '@inquiries/-lib/inquiryValidation'
import { type KeyboardEvent, useCallback, useState } from 'react'
import { validateForm } from '@/lib/form-validation'
import { useAuthStore } from '@/stores/auth'
import { useCreateInquiryCoordination } from './useCreateInquiryCoordination'

export function useCoordinationCreate(inquiryId: number) {
  const createCoordination = useCreateInquiryCoordination(inquiryId)
  const memberId = useAuthStore((s) => s.user?.memberId)

  const [newContent, setNewContent] = useState('')
  const [contentError, setContentError] = useState<string | null>(null)

  // TODO: canSubmitに!!memberIdを含める & mutation のonSuccess/onErrorにsonnerのtoast通知を追加（CommentsSection参照）
  const canSubmit = isCoordinationContentValid(newContent) && !createCoordination.isPending

  const handleSubmit = useCallback(async () => {
    if (!memberId) return
    const { success, errors } = validateForm(inquiryCoordinationSchema, { content: newContent })
    if (!success) {
      setContentError(errors.content ?? null)
      return
    }
    setContentError(null)
    try {
      await createCoordination.mutateAsync({ memberId, content: newContent.trim() })
      setNewContent('')
    } catch {}
  }, [newContent, memberId, createCoordination.mutateAsync])

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLTextAreaElement>) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault()
        handleSubmit()
      }
    },
    [handleSubmit],
  )

  const handleContentChange = useCallback((value: string) => {
    setNewContent(value)
    setContentError(getCoordinationContentMaxLengthError(value))
  }, [])

  return {
    newContent,
    contentError,
    canSubmit,
    isPending: createCoordination.isPending,
    handleSubmit,
    handleKeyDown,
    handleContentChange,
  }
}
